import React from 'react';
import { withRouter } from 'Components/withRouter';
import styles from './ErrorPage.module.css';

class ErrorPage extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        var error = this.props.router.location.state.error;

        return (
            <div styleName="styles.errorMessage">
                <h1>
                    Oops! Something went wrong.
                </h1>
                {
                    error && <p>{error.message}</p>
                }
            </div>
            );
    }
}

const ErrorPageWithRouter = withRouter(ErrorPage);

export { ErrorPageWithRouter as ErrorPage };
